import React from 'react';
import { ASSESSMENT_STATUS } from '../lib/status';

/** Compact legend of assessment states. */
export default function StatusLegend() {
  const items = [['complete', 'Complete'], ['active', 'Collecting'], ['scheduled', 'Scheduled'], ['locked', 'Locked']];
  return (
    <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
      {items.map(([k, label]) => {
        const m = ASSESSMENT_STATUS[k];
        return (
          <span key={k} style={{ display: 'inline-flex', alignItems: 'center', gap: 7, fontFamily: 'var(--font-sans)', fontSize: 'var(--text-xs)', color: 'var(--ink-muted)' }}>
            <span style={{
              width: 12, height: 12, borderRadius: 999,
              background: k === 'complete' ? m.fill : '#fff',
              border: k === 'complete' ? 'none' : `2px solid ${m.ring}`, boxSizing: 'border-box',
            }} />
            {label}
          </span>
        );
      })}
    </div>
  );
}
